import { Button, Card, Col, Drawer, Row, Form, Input, Popconfirm, InputNumber, Select } from 'antd';
import React, { useEffect, useState } from 'react'
import UnitService from '../../services/UnitService';
import { DeleteOutlined } from '@ant-design/icons'
import TextArea from 'antd/es/input/TextArea';
import { openNotification } from '../../utils';

interface UnitsItemCardProps {
    unit: any;
    getTrigger: any;
    lessons: any
}

const { Item } = Form;

const UnitsItemCard: React.FC<UnitsItemCardProps> = ({ unit, getTrigger, lessons }) => {
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();

    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        if (open) {
            getService();
        }
    }, [open])



    const getService = () => {
        setLoading(true)
        UnitService.get(unit?.id)
            .then((response: any) => {
                const data = response.data
                form.setFieldsValue({
                    name: data?.name,
                    description: data?.description,
                    lessonId: data?.lessonId,
                });
                setLoading(false)
            })
            .catch((e: Error) => {
                console.log(e);
            });
    };

    const update = (values: any) => {
        let postObj = {
            "name": values.name,
            "description": values.description,
            "lessonId": values.lessonId,
        }

        UnitService.update(unit?.id, postObj)
            .then((response: any) => {
                getTrigger();
                openNotification('success', 'Başarılı', 'Ünite Başarıyla Kaydedildi.')
            }).catch((e: Error) => {
                openNotification('error', 'Başarısız', 'Ünite Kaydedilemedi.')
            });
    }

    const removeUnit = (values: any) => {
        UnitService.remove(unit?.id)
            .then((response: any) => {
                getTrigger();
                openNotification('success', 'Başarılı', 'Ünite Başarıyla Silindi.')
            }).catch((e: Error) => {
                openNotification('error', 'Başarısız', 'Ünite silinemedi.')
            });
    }

    const findLessonName = (lessonId: number) => {
        const lesson = lessons.find((lesson: any) => lesson.value === lessonId);
        return lesson ? lesson.label : '';
    }

    return (
        <>
            <Card>
                <Row align={'middle'} justify={'space-around'}>
                    <Col>
                        <p><b>ID:</b></p>
                        {unit.id}
                    </Col>
                    <Col>
                        <p><b> Ünite:</b></p>
                        {unit.name}
                    </Col>
                    <Col>
                        <p><b>Açıklama:</b></p>
                        {unit.description}
                    </Col>
                    <Col>
                        <p><b>Ders:</b></p>
                        {findLessonName(unit.lessonId)}
                    </Col>
                    <Col>
                        <Button onClick={showDrawer}>
                            Detay
                        </Button>
                    </Col>
                    <Col>
                        <Popconfirm
                            title="Ünite silinsin mi?"
                            onConfirm={() => removeUnit(unit.id)}
                            okText="Evet"
                            cancelText="Hayır"
                        >
                            <DeleteOutlined
                                className='cursor-pointer' />
                        </Popconfirm>
                    </Col>
                </Row>
            </Card>
            <Drawer title="Ünite Detay" placement="right" onClose={onClose} open={open} extra={<b>#{unit?.id}</b>}>
                <Card loading={loading}>
                    <Form form={form} onFinish={update} layout="vertical">
                        <Item
                            name="name"
                            label="Ünite"
                            rules={[
                                {
                                    required: true,
                                    message: 'Ünite adı zorunlu',
                                }]}
                        >
                            <Input />
                        </Item>
                        <Item
                            name="description"
                            label="Açıklama"
                        >
                            <TextArea />
                        </Item>
                        <Item
                            name="lessonId"
                            label="Ders"
                            rules={[
                                {
                                  required: true,
                                  message: 'Lütfen bir ders seçin', // Kullanıcı alanı boş bıraktığında gösterilecek mesaj
                                },
                              ]}
                        >
                            <Select options={lessons} />
                        </Item>
                        <Item>
                            <Row justify={'end'}>
                                <Button className='btn btn-hover-dark bg-cloud font-color-onyx btn-text mr-16' onClick={onClose}>
                                    Vazgeç
                                </Button>
                                <Button  className='btn btn-hover-dark bg-slate-blue font-color-cloud btn-text' htmlType="submit">
                                    Kaydet
                                </Button>
                            </Row>
                        </Item>
                    </Form>
                </Card>
            </Drawer>
        </>
    )
}

export default UnitsItemCard